












































































import Vue from "vue";
import {
  ROUTES,
  VUEX_ASSIGNMENT_ACTION_NAMES,
  VUEX_ASSIGNMENT_NAMESPACE,
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE,
  VUEX_ROOT_GETTER_NAMES
} from "@tt-app/constants";
import {
  Answers,
  ExerciseAccuracy,
  ExerciseResults,
  Page,
  WordSelectAudio,
  WordSelectComponent,
  WordSelectExampleSentence,
  WordSelectOptions,
  WordSelectSentence,
  WordSelectSentenceElement
} from "@tt-app/types";
import { Location } from "vue-router";
import { FlatExerciseListDetails, nextExerciseRouter } from "@tt-app/utils";

import AssignmentCompletionModal from "@tt-app/components/assignment/AssignmentCompletionModal.vue";
import ChatText from "@tt-app/components/exercise/common/ChatText.vue";
import ExerciseHeaderTitle from "@tt-app/components/exercise/ExerciseHeaderTitle.vue";
import LayoutExercise from "@tt-app/layouts/LayoutExercise.vue";
import WordSelectQuestionCard from "@tt-app/components/exercise/wordSelect/WordSelectQuestionCard.vue";
import WordSelectReviewCard from "@tt-app/components/exercise/wordSelect/WordSelectReviewCard.vue";

import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import TrophyBronzeStandard from "@joyz/app-core/assets/trophy/gif/Bronze.gif";
import TrophyBronzeNewRecord from "@joyz/app-core/assets/trophy/gif/BronzeNewRecord.gif";
import TrophySilverStandard from "@joyz/app-core/assets/trophy/gif/Silver.gif";
import TrophySilverNewRecord from "@joyz/app-core/assets/trophy/gif/SilverNewRecord.gif";
import TrophyGoldStandard from "@joyz/app-core/assets/trophy/gif/Gold.gif";
import TrophyGoldNewRecord from "@joyz/app-core/assets/trophy/gif/GoldNewRecord.gif";
import FeedbackPopup from "@tt-app/components/feedback/FeedbackPopup.vue";
import ExerciseTrophy from "@tt-app/components/exercise/common/ExerciseTrophy.vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import {
  Session,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { audioContext } from "@tt-app/utils/audio/audioContext";

const { DETAILS_REQUEST } = VUEX_ASSIGNMENT_ACTION_NAMES;
const { FLAT_EXERCISE_LIST } = VUEX_ROOT_GETTER_NAMES;

const {
  CLEAR_EXERCISE,
  EXERCISE_DETAILS_REQUEST,
  LOG_EXERCISE_START,
  LOG_EXERCISE_END,
  LOG_EXERCISE_ANSWER,
  RESET_EXERCISE,
  RESTART_EXERCISE
} = VUEX_EXERCISE_ACTION_NAMES;
const { DETAILS, EXERCISE_ACCURACY, EXERCISE_RESULTS, LOG_ID } = VUEX_EXERCISE_GETTER_NAMES;

interface Data {
  answers: Answers;
  audioDecoderPlayer: AudioDecoderPlayer;
  currentPageIndex: number;
  displayExitConfirmation: boolean;
  fallback: any;
  feedbackFormVisible: boolean;
  icons: any;
  limitedModeUpdated: boolean;
  processing: boolean;
  requireExitConfirmation: boolean;
  trophyVisible: boolean;
}

interface Methods {
  clearExercise: () => void;
  closeIconClickHandler: () => void;
  dynamicComponent(componentDefinition: any): string;
  endExerciseClickHandler: () => void;
  exit: () => void;
  exitCancellationHandler: () => void;
  exitConfirmationHandler: () => void;
  fetchAssignmentDetails: () => void;
  fetchExercise: () => void;
  handleFeedbackClose: () => void;
  incrementPageIndex: (amount?: number) => void;
  logAnswersAndShowTrophy: () => void;
  logExerciseEnd: () => void;
  logExerciseStart: () => void;
  refreshAudioPlayer: () => void;
  restartExercise: () => void;
  scrollToTop: () => void;
  statusChangeHandler: (payload: any) => void;
}

interface Computed {
  actual: any;
  assignmentId?: string;
  assignmentsCompleted: number;
  chapter: any;
  components: WordSelectComponent[];
  course: any;
  courseUuid: any;
  currentExerciseListIndex: number | null;
  currentPage: any;
  exercise: any;
  exerciseAccuracy: ExerciseAccuracy;
  exerciseResults: ExerciseResults;
  exerciseType: any;
  exerciseUuid: any;
  flatExerciseList: FlatExerciseListDetails[];
  header: any;
  isReviewPage: any;
  limitedModeActive: boolean;
  logId: any;
  newRecord: any;
  nextExercise?: FlatExerciseListDetails;
  nextExerciseButtonText: string;
  numCorrectAnswers: any;
  numIncorrectAnswers: any;
  pages: Page[];
  problems: any;
  resultsButtonDisabled: any;
  reviewComponents: any;
  showFeedbackForm: boolean;
  section: any;
  session: Session;
  pageQuestions: any;
  totalQuestions: any;
  trophy: any;
  trophyComment: any;
  trophyEffectiveUrl?: string;
}

export default Vue.extend<Data, Methods, Computed>({
  name: "QuizTranslation",
  components: {
    ExerciseTrophy,
    AssignmentCompletionModal,
    FeedbackPopup,
    ChatText,
    ExerciseHeaderTitle,
    LayoutExercise,
    WordSelectQuestionCard,
    WordSelectReviewCard
  },
  beforeRouteLeave(_to, _from, next) {
    if (!this.requireExitConfirmation) {
      next();
      return;
    }

    this.displayExitConfirmation = true;
    this.limitedModeUpdated = _to.params.limitedMode === "true";
    next(false);
  },
  data() {
    let fallback: Location;

    if (this.$route.params.assignmentId && this.$store.state.assignment.details) {
      fallback = {
        name: ROUTES.ASSIGNMENT.DETAILS.NAME,
        params: {
          assignmentId: this.$route.params.assignmentId
        }
      };
    } else {
      fallback = {
        name: ROUTES.COURSE.DETAILS.NAME,
        params: {
          courseUuid: this.$route.params.courseUuid
        }
      };
    }

    return {
      answers: {},
      audioDecoderPlayer: new AudioDecoderPlayer({ audioContext }),
      currentPageIndex: 0,
      displayExitConfirmation: false,
      fallback,
      feedbackFormVisible: true,
      icons: {
        correct: IconCorrect,
        incorrect: IconIncorrect
      },
      limitedModeUpdated: false,
      processing: false,
      requireExitConfirmation: false,
      trophyVisible: false
    };
  },
  async created() {
    if (this.assignmentId) {
      await this.fetchAssignmentDetails();
    }

    this.fetchExercise();
    document.addEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  beforeDestroy() {
    this.clearExercise();
    this.audioDecoderPlayer.destroy();
    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  computed: {
    actual() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${DETAILS}`];
    },

    assignmentId() {
      return this.$route.params.assignmentId;
    },

    assignmentsCompleted() {
      const completedCount = this.exerciseResults?.numAssignmentsSubmitted;
      return completedCount || 0;
    },

    chapter() {
      return this.actual?.chapter;
    },

    course() {
      return this.actual?.course;
    },

    courseUuid() {
      return this.$route.params.courseUuid;
    },

    components() {
      if (!this.pages) return [];
      return this.isReviewPage ? this.reviewComponents : this.pages[this.currentPageIndex].body;
    },

    currentExerciseListIndex() {
      const listIndex = this.flatExerciseList.findIndex(
        (exerciseDetails: FlatExerciseListDetails) => {
          return exerciseDetails.uuid === this.exerciseUuid;
        }
      );

      return listIndex >= 0 ? listIndex : null;
    },

    currentPage() {
      if (!this.pages) return undefined;
      return this.pages[this.currentPageIndex];
    },

    exercise() {
      return this.actual?.exercise;
    },

    exerciseAccuracy() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_ACCURACY}`];
    },

    exerciseResults() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_RESULTS}`];
    },

    exerciseType() {
      return 11;
    },

    exerciseUuid() {
      return this.$route.params.exerciseUuid;
    },

    flatExerciseList() {
      return this.$store.getters[FLAT_EXERCISE_LIST]({
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid
      });
    },

    header() {
      return {
        courseTitle: this.course?.title,
        chapterTitle: this.chapter?.title,
        exerciseTitle: this.exercise?.title,
        sectionTitle: this.section?.title
      };
    },

    isReviewPage() {
      const currentPageType = this.currentPage?.body[0].type;
      return currentPageType === "REVIEW";
    },

    limitedModeActive() {
      return Boolean(this.session?.limitedMode?.id);
    },

    logId() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${LOG_ID}`];
    },

    newRecord() {
      if (!this.exerciseResults) return false;

      return this.exerciseResults.prevBestTrophy < this.exerciseResults.trophy;
    },

    nextExercise() {
      if (this.currentExerciseListIndex === null) return undefined;
      return this.flatExerciseList[this.currentExerciseListIndex + 1];
    },

    nextExerciseButtonText() {
      const i18nString = this.nextExercise ? "exercise.next" : "exercise.end";

      return this.$__(i18nString);
    },

    numCorrectAnswers() {
      if (!this.exerciseAccuracy) return undefined;

      const correctAnswers = Object.entries(this.exerciseAccuracy).filter(([, accuracy]) => {
        return accuracy.isCorrect;
      });

      return correctAnswers.length;
    },

    numIncorrectAnswers() {
      if (!this.exerciseAccuracy) return undefined;

      const correctAnswers = Object.entries(this.exerciseAccuracy).filter(([, accuracy]) => {
        return !accuracy.isCorrect;
      });

      return correctAnswers.length;
    },

    pages() {
      return this.exercise?.pages;
    },

    problems() {
      if (!this.pages) return undefined;
      const problemComponents = this.pages[0].body;

      const problemsByUuid: {
        [key: string]: {
          audio?: {
            type: string;
            url: string;
          };
          plainText: string[];
          structure: WordSelectSentenceElement[];
          options: WordSelectOptions[];
        };
      } = {};

      problemComponents.forEach(problem => {
        if (!problem.body || !problem.problemUuid) return undefined;

        const audio = (problem.body as Array<WordSelectAudio>).filter(element => {
          return element.type === "AUDIO";
        });

        const plainText = (problem.body as Array<WordSelectExampleSentence>).filter(element => {
          return element.type === "PLAIN_TEXT";
        });

        const sentence = (problem.body as Array<WordSelectSentence>).filter(element => {
          return element.type === "WORD_SELECT_SENTENCE";
        });

        const options = (problem.body as Array<WordSelectOptions>).filter(element => {
          return element.type === "WORD_SELECT_OPTIONS";
        });

        problemsByUuid[problem.problemUuid] = {
          audio: audio[0],
          plainText: plainText[0]?.body,
          structure: sentence[0].structure,
          options: options
        };
      });

      return problemsByUuid;
    },

    resultsButtonDisabled() {
      const exerciseLoaded = Boolean(this.exercise);
      const allQuestionsAnswered =
        this.pageQuestions === Object.values(this.answers).filter(Boolean).length;
      const processing = this.processing;

      if (!exerciseLoaded) return true;

      return !this.isReviewPage && (!allQuestionsAnswered || (allQuestionsAnswered && processing));
    },

    reviewComponents() {
      if (!this.isReviewPage) return undefined;
      return this.exerciseResults.reviewPage.body;
    },

    section() {
      return this.actual?.section;
    },

    session() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    },

    showFeedbackForm() {
      return this.feedbackFormVisible && this.isReviewPage;
    },

    pageQuestions() {
      return this.components.filter(component => {
        return component.type === "WORD_SELECT";
      }).length;
    },

    totalQuestions() {
      return this.exercise.pages[0].body.filter((body: any) => {
        return body.type === "WORD_SELECT";
      }).length;
    },

    trophy() {
      if (!this.exerciseResults) {
        return;
      }

      return {
        comment: this.trophyComment,
        correctCount: this.numCorrectAnswers,
        incorrectCount: this.numIncorrectAnswers,
        score: this.exerciseResults.trophy
      };
    },

    trophyComment() {
      if (!this.exerciseResults) return "";

      const trophies: {
        [key: number]: string;
      } = {
        1: "bronze",
        2: "silver",
        3: "gold"
      };

      return this.$__(
        `ex.trophy.${trophies[this.exerciseResults.trophy]}`,
        this.exerciseResults.moreCorrectAnswers
      );
    },

    trophyEffectiveUrl() {
      const score = this.exerciseResults?.trophy;

      if (!score) return undefined;

      switch (score) {
        case 1:
          return this.newRecord ? TrophyBronzeNewRecord : TrophyBronzeStandard;
        case 2:
          return this.newRecord ? TrophySilverNewRecord : TrophySilverStandard;
        case 3:
          return this.newRecord ? TrophyGoldNewRecord : TrophyGoldStandard;
        default:
          return "";
      }
    }
  },
  methods: {
    clearExercise() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${CLEAR_EXERCISE}`);
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${RESET_EXERCISE}`);
    },

    closeIconClickHandler() {
      this.exit();
    },

    dynamicComponent(componentDefinition) {
      switch (componentDefinition.type) {
        case "CARD":
          return "word-select-review-card";
        case "CHAT_TEXT":
          return "chat-text";
        case "WORD_SELECT":
          return "word-select-question-card";
        default:
          return "";
      }
    },

    endExerciseClickHandler() {
      nextExerciseRouter({
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid,
        ...this.nextExercise
      });
    },

    exit() {
      const isReview = (this as any).isReviewPage;
      const logId = (this as any).logId.toString();

      let routeParams = {};
      if (isReview !== undefined) {
        routeParams = { withFeedback: Boolean(!isReview).toString(), logId: logId.toString() };
      }

      const fallbackDest: Location = {
        ...this.fallback,
        params: { feedbackParams: routeParams }
      } || {
        name: ROUTES.HOME.NAME,
        params: { feedbackParams: routeParams }
      };

      this.$router.replace(fallbackDest).catch(function() {
        console.log("routing canceled");
      });
    },

    exitCancellationHandler() {
      this.displayExitConfirmation = false;
    },

    exitConfirmationHandler() {
      this.requireExitConfirmation = false;

      this.exit();
    },

    async fetchAssignmentDetails() {
      await this.$store.dispatch(`${VUEX_ASSIGNMENT_NAMESPACE}/${DETAILS_REQUEST}`, {
        assignmentId: this.$route.params.assignmentId
      });
    },

    fetchExercise() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_DETAILS_REQUEST}`, {
        courseUuid: this.courseUuid,
        exerciseType: this.exerciseType,
        exerciseUuid: this.exerciseUuid
      });
    },

    handleFeedbackClose() {
      this.feedbackFormVisible = false;
    },

    async incrementPageIndex(amount = 1) {
      this.currentPageIndex = this.currentPageIndex + amount;

      await this.$nextTick();

      this.scrollToTop();
    },

    async logAnswersAndShowTrophy() {
      this.processing = true;

      const answerPromises = Object.entries(this.answers).map(([problemUuid, selections]) => {
        const withoutId = selections[0];

        let answer;
        if (withoutId) {
          answer = selections[0].map(selection => {
            return selection.option.number;
          });
        } else {
          answer = Object.entries(selections).reduce((previousResult, [, currentProblemAnswer]) => {
            const nextAnswer = currentProblemAnswer[0].option.number;
            return [...previousResult, nextAnswer];
          }, [] as number[]);
        }

        const payload = {
          answer,
          courseUuid: this.courseUuid,
          exerciseType: this.exerciseType,
          exerciseUuid: this.exerciseUuid,
          logId: this.logId,
          problemUuid
        };

        return this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_EXERCISE_ANSWER}`, payload);
      });

      await Promise.all(answerPromises);

      await this.logExerciseEnd();
      await this.incrementPageIndex();

      this.processing = false;
    },

    async logExerciseEnd() {
      const payload = {
        courseUuid: this.courseUuid,
        exerciseType: this.exerciseType,
        exerciseUuid: this.exerciseUuid,
        logId: this.logId,
        numCorrectAnswers: this.numCorrectAnswers,
        numIncorrectAnswers: this.numIncorrectAnswers
      };

      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_EXERCISE_END}`, payload);
      this.requireExitConfirmation = false;
    },

    logExerciseStart() {
      this.requireExitConfirmation = true;
      const payload: any = {
        courseUuid: this.courseUuid,
        exerciseType: this.exerciseType,
        exerciseUuid: this.exerciseUuid,
        limitedModeId: this.session?.limitedMode?.id,
        sessionId: this.session?.id
      };
      if (Number(this.assignmentId)) {
        payload.assignmentId = Number(this.assignmentId);
      }
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_EXERCISE_START}`, payload);
    },

    refreshAudioPlayer() {
      if (document.visibilityState === "visible") {
        console.log("refreshing audio player");
        this.audioDecoderPlayer = new AudioDecoderPlayer({ audioContext });
      }
    },

    async restartExercise() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${RESTART_EXERCISE}`);
      this.answers = {};
      this.currentPageIndex = 0;
      this.feedbackFormVisible = true;
      this.logExerciseStart();

      this.scrollToTop();
    },

    scrollToTop() {
      const container = document.getElementsByClassName("quiz-translation-content-container")[0];

      container.scrollTo(0, 0);
    },

    statusChangeHandler(payload) {
      if (payload.status === "complete") {
        this.answers = {
          ...this.answers,
          [payload.problemUuid]: payload.selections
        };
      } else {
        this.answers = {
          ...this.answers,
          [payload.problemUuid]: undefined
        };
      }
    }
  },
  watch: {
    requireExitConfirmation: {
      handler(newValue) {
        window.onbeforeunload = null;

        if (newValue) {
          window.onbeforeunload = () => {
            return true;
          };
        }
      }
    },
    exercise(newValue) {
      if (newValue) {
        this.logExerciseStart();
      }
    }
  }
});
